import { useTranslation } from 'react-i18next';

import { Select, SelectOption } from '@/core/components/inputs/Select';

const languages: SelectOption[] = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
];

const shortLanguages: SelectOption[] = [
  { value: 'en', label: 'EN' },
  { value: 'es', label: 'ES' },
];

export function LanguageSwitcher({ short, className }: { short?: boolean; className?: string }) {
  const { i18n } = useTranslation();

  const handleLanguageChange = (value: string | string[]) => {
    if (typeof value === 'string') {
      i18n.changeLanguage(value);
    }
  };

  return (
    <Select
      className={className}
      options={short ? shortLanguages : languages}
      value={i18n.language}
      onChange={handleLanguageChange}
      label="Language"
      hideLabel
      placeholder="Select language"
    />
  );
}
